import {ApiError, Levels} from '@/api/error';
import HealthState from "@/types/HealthState";
import EnvironmentInfo from "@/types/EnvironmentInfo";

export default class EnvironmentInfoService {

    static getEnvironmentInfo(): Promise<EnvironmentInfo> {
        return fetch(EnvironmentInfoService.getBackendUrl() + `/api/environmentInfo`)
            .then(response => {
                if (!response.ok) {
                    console.error("Beim Laden der EnvironmentInfo vom API-Gateway ist ein Fehler aufgetreten.");
                }
                return response.json();
            })
            .catch(error => {
                throw new ApiError({
                    level: Levels.ERROR,
                    message: "Verbindung zum API-Gateway konnte nicht aufgebaut werden."
                });

            })
    }

    static getBackendUrl() {
        if (window.location.hostname === 'localhost' && window.location.port === '8081') {
          return 'http://localhost:8082';
        } else {
          return '';
        }
    }
}
